import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
// 定数
const reasonColorList = {
  absencePointsMap: "#3685BB",
  ["欠席-嘔吐下痢"]: "#775DD0",
  ["欠席-腹痛"]: "#FF4560",
  ["体調不良"]: "#33B2DF",
  ["infection"]: "#D4526E",
  ["コロナ関連"]: "#546E7A",
  ["37.5度以上"]: "#00E396"
};
const fiscalStart = moment([moment().subtract(3, "months").year(), 3, 1]); // momentなので月は0スタート 今回は4月を指定している

const __default__ = {
  data() {
    return {
      map: {},
      popup: new mapboxgl.Popup({
        className: "popup"
      }),
      reason: "absencePointsMap",
      geoJsonData: {},
      first: true,
      markerList: [],
      lastZoomLevel: 12
    };
  },
  watch: {
    filterSchoolPointList: function () {
      if (this.first) {
        const [bounds, boundsPadding] = this.editBounds();
        this.pointsMap(bounds, boundsPadding);
        this.first = false;
      } else {
        this.map.removeLayer("unclustered-point");
        this.map.removeLayer("unclustered-count");
        this.map.removeSource("earthquakes");
        this.editBounds();
        this.createGeoJsonData();
        this.addSource();
        this.addLayer();
      }
      this.createMarker();
    },
    reason: function () {
      this.map.removeLayer("unclustered-point");
      this.map.removeLayer("unclustered-count");
      this.map.removeSource("earthquakes");
      this.editBounds();
      this.createGeoJsonData();
      this.addSource();
      this.addLayer();
      this.createMarker();
    }
  },
  methods: {
    onChange(e) {
      this.map.setStyle(`mapbox://styles/mapbox/${e.target.id}`);
    },
    onReasonChange(e) {
      this.reason = e.target.value;
    },
    pointsMap(bounds, boundsPadding) {
      mapboxgl.accessToken = "pk.eyJ1Ijoic291dGFpdG8iLCJhIjoiY2t1MHQyaGxjMWhxczJ2dGh2OGJ3NGc4dCJ9.jiagpyhpWWZBJEgiqcfGyA";
      this.map = new mapboxgl.Map({
        container: "map",
        style: `mapbox://styles/mapbox/satellite-v9`,
        bounds: bounds,
        fitBoundsOptions: {
          padding: boundsPadding
        }
      });
      this.createGeoJsonData();
      this.map.on("load", () => {
        this.addSource();
        this.addLayer();
        this.createMarker();
        this.map.on("mousemove", "unclustered-point", e => {
          const coordinates = e.features[0].geometry.coordinates.slice();
          const school = e.features[0].properties.school;
          const schoolId = e.features[0].properties.schoolId;
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          this.popup.setLngLat(coordinates).setHTML(`<a href="#" onclick="event.preventDefault(); Vue.router.push('/school/${schoolId}');">${school}</a><br>${e.features[0].properties.absence}`).addTo(this.map);
        });
        this.map.on("mousemove", e => {
          // console.log(this.map.getZoom());
          const features = this.map.queryRenderedFeatures(e.point)[0];
          if (features === undefined || features.source !== "earthquakes") {
            this.popup.remove();
          }
        });
        this.map.on("mouseenter", "unclustered-point", () => {
          this.map.getCanvas().style.cursor = "pointer";
        });
        this.map.on("mouseleave", "unclustered-point", () => {
          this.map.getCanvas().style.cursor = "";
        });
        this.map.on("style.load", () => {
          this.addSource();
          this.addLayer();
        });
        this.map.on("zoom", () => {
          this.createMarker();
        });
      });
    },
    createGeoJsonData() {
      this.geoJsonData = {
        type: "FeatureCollection",
        features: this.filterSchoolPointList.map(v => {
          const filterAbsenceStr = Object.keys(v.absence).map(key => `&nbsp;${key}: ${v.absence[key]}名`);
          let alertText = "";
          // alert用テキスト
          if (v.pointMap["体調不良"] && v.pointMap["体調不良"] / v.student_count >= 0.1) {
            alertText += `<span style="color:red;">★</span>`;
          }
          if (v.pointMap["欠席-嘔吐下痢"] && v.pointMap["欠席-嘔吐下痢"] / v.student_count >= 0.01) {
            alertText += `<span style="color:blue;">★</span>`;
          }
          if (v.pointMap["infection"] && v.pointMap["infection"] / v.student_count >= 0.05) {
            alertText += `<span style="color:green;">★</span>`;
          }
          if (v.pointMap["37.5度以上"] && v.pointMap["37.5度以上"] / v.student_count >= 0.1) {
            alertText += `<span style="color:yellow;">★</span>`;
          }
          const count = v.pointMap[this.reason] ?? 0;
          // 表示位置微調整用
          const alertOffset = count < 10 ? 10 : count < 20 ? 15 : count < 50 ? 17 : 20;
          return {
            type: "Feature",
            properties: {
              count: count,
              school: v.name,
              schoolId: v.id,
              absence: "内訳<br>" + filterAbsenceStr.join("<br>"),
              alert: alertText,
              alertOffset: alertOffset
            },
            geometry: {
              type: "Point",
              coordinates: [v.longitude, v.latitude]
            }
          };
        })
      };
    },
    editBounds() {
      // [[w, s],[e, n]]
      const bounds = this.filterSchoolPointList.reduce((pre, current, i) => {
        if (i === 0) {
          pre[0][0] = current.longitude;
          pre[0][1] = current.latitude;
          pre[1][0] = current.longitude;
          pre[1][1] = current.latitude;
        } else {
          pre[0][0] = pre[0][0] < current.longitude ? pre[0][0] : current.longitude;
          pre[0][1] = pre[0][1] < current.latitude ? pre[0][1] : current.latitude;
          pre[1][0] = pre[1][0] > current.longitude ? pre[1][0] : current.longitude;
          pre[1][1] = pre[1][1] > current.latitude ? pre[1][1] : current.latitude;
        }
        return pre;
      }, [[130, 34], [145, 40]]);
      const boundsPadding = {
        bottom: 30,
        top: this.isShowMenu ? 100 : 30,
        right: 30,
        left: 30
      };
      if (this.first) {
        return [bounds, boundsPadding];
      } else {
        this.map.fitBounds(bounds, {
          linear: true,
          padding: boundsPadding
        });
      }
    },
    createMarker() {
      if (this.markerList.length) {
        // 古いマーカーを削除
        for (const mark of this.markerList) {
          mark.remove();
        }
      }

      // Add markers to the map.
      const zoomCorrection = Math.pow(2, this.lastZoomLevel) / Math.pow(2, this.map.getZoom());
      this.lastZoomLevel = this.map.getZoom();
      for (const marker of this.geoJsonData.features) {
        if (marker.properties.alert !== "") {
          // Create a DOM element for each marker.
          const el = document.createElement("div");
          // el.className = "marker";
          el.innerHTML = marker.properties.alert;
          const coordinates = this.map.project(marker.geometry.coordinates);
          const offsetcoordinates = this.map.unproject([coordinates.x + marker.properties.alertOffset * zoomCorrection, coordinates.y - marker.properties.alertOffset * zoomCorrection]);
          const mark = new mapboxgl.Marker(el).setLngLat([offsetcoordinates.lng, offsetcoordinates.lat]).addTo(this.map);
          this.markerList.push(mark);
        }
      }
    },
    addSource() {
      this.map.addSource("earthquakes", {
        type: "geojson",
        data: this.geoJsonData,
        cluster: false
      });
    },
    addLayer() {
      this.map.addLayer({
        id: "unclustered-point",
        type: "circle",
        source: "earthquakes",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": reasonColorList[this.reason],
          "circle-radius": ["step", ["get", "count"], 10, 5, 15, 10, 20, 20, 25, 50, 30],
          "circle-stroke-width": 2,
          "circle-stroke-color": "#fff"
        }
      });
      this.map.addLayer({
        id: "unclustered-count",
        type: "symbol",
        source: "earthquakes",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "text-color": "#ffffff"
        },
        layout: {
          "text-field": "{count}",
          "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
          "text-size": 12
        }
      });
    }
  }
};
import { ref, toRefs, computed, watch, inject } from "vue";
import mapboxgl from "mapbox-gl";
import moment from "moment";
import { debounce } from "throttle-debounce";
import { getData } from "@/services/axios";

import { isAuthenticatedKey, allSchoolListKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'PointsMap',
  props: {
    height: {
      type: String,
      default: "580px"
    },
    isShowMenu: {
      type: Boolean,
      default: true
    },
    activeGrade: {
      type: String,
      default: "all"
    },
    selectedDay: {
      type: String,
      default: moment().format("YYYY-MM-DD")
    },
    currentObj: {
      type: Object,
      default: moment()
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const isAuthenticated = inject(isAuthenticatedKey);
    const allSchoolList = inject(allSchoolListKey);

    // eslint-disable-next-line vue/valid-define-props

    const {
      height,
      isShowMenu,
      activeGrade,
      selectedDay,
      currentObj
    } = toRefs(props);
    const mapDateMaxDiff = ref(moment().diff(fiscalStart, "days"));
    const mapDateNum = ref(mapDateMaxDiff.value);
    const mapDateSelect = ref(moment(selectedDay.value));
    const mapDateFormat = ref(mapDateSelect.value.format("YYYY/MM/DD"));

    // ダッシュボード全体の日付が変更された際
    watch(() => selectedDay.value, () => {
      mapDateNum.value = moment(selectedDay.value).diff(fiscalStart, "days");
      mapDateSelect.value = moment(selectedDay.value);
    });
    const allSchoolPointList = ref([]);
    const filterSchoolPointList = computed(() => {
      return activeGrade.value === "all" ? allSchoolPointList.value.slice() : allSchoolPointList.value.filter(v => v.type === activeGrade.value);
    });

    // apiからデータ取得
    const getPointMapData = async () => {
      if (isAuthenticated.value) {
        const data = await getData(`attendance_summary?pointMap=1&date=${mapDateSelect.value.format("YYYY-MM-DD")}`);
        allSchoolPointList.value = structuredClone(allSchoolList.value).map(v => {
          if (data.items[v.id]) {
            v["pointMap"] = data.items[v.id]["pointMap"];
            v["absence"] = data.items[v.id]["absence"];
          } else {
            // 欠席者がいない場合
            v["pointMap"] = {
              absencePointsMap: 0,
              "欠席-嘔吐下痢": 0,
              "欠席-腹痛": 0,
              体調不良: 0,
              infection: 0,
              コロナ関連: 0,
              "37.5度以上": 0
            };
            v["absence"] = [];
          }
          return v;
        });
      }
    };

    // authに変化があれば取得
    // authがtrueであることが分かる時点で学校情報も取得できている
    watch(isAuthenticated, () => {
      getPointMapData();
    }, {
      immediate: true
    });
    const getPointMapDataDebounce = debounce(250, getPointMapData);
    // mapのみ日付を変更した場合
    watch(mapDateNum, () => {
      mapDateSelect.value = fiscalStart.clone().add(mapDateNum.value, "days");
      mapDateFormat.value = mapDateSelect.value.format("YYYY/MM/DD");
      getPointMapDataDebounce();
    });

    // 10分ごとの再読み込み時
    watch(() => currentObj.value, () => {
      mapDateMaxDiff.value = ref(currentObj.value.diff(fiscalStart, "days"));
      getPointMapData();
    });

    // map高さのスタイル
    const mapHeight = computed(() => {
      return {
        "--map-height": height.value
      };
    });
    expose({
      isShowMenu,
      filterSchoolPointList
    });
    return {
      __sfc: true,
      reasonColorList,
      fiscalStart,
      isAuthenticated,
      allSchoolList,
      props,
      height,
      isShowMenu,
      activeGrade,
      selectedDay,
      currentObj,
      mapDateMaxDiff,
      mapDateNum,
      mapDateSelect,
      mapDateFormat,
      allSchoolPointList,
      filterSchoolPointList,
      getPointMapData,
      getPointMapDataDebounce,
      mapHeight
    };
  }
});